$(function() {
  const BaseModule = require('_base/base')

  class FitToContentModule extends BaseModule {
    get alignmentClasses() {
      return this.$el
        .attr('class')
        .split(' ')
        .filter(klass => /is__align-/.test(klass))
        .join(' ') || 'is__align-self-center'
    }

    preInit() {
      this.$labeledMediaWrapper = this.$el.parent('.labeledMediaWrapper')

      this.CLASS_ORIGINAL = 'is__original'
      this.CLASS_FITTED = 'is__fitted'
      this.FLEX_DEFAULTS = '0 1 auto'
    }

    postInit() {
      this.initialCssWidth = this.$el[0].style.width;
      this.initialCssHeight = this.$el[0].style.height;
      this.initialWidth = this.$el.data('width');
      this.initialHeight = this.$el.data('height');

      const initialFlex = ['flex-grow', 'flex-shrink', 'flex-basis']
        .map(prop => this.$el.css(prop))
        .join(' ');
      this.initialFlex = initialFlex || this.FLEX_DEFAULTS;

      this.ratio = this.initialWidth / this.initialHeight;

      this.isBordered = this.$el.hasClass('is__bordered');
      this.isCutted = this.$el.hasClass('is__cutOffBelow');

      this.border = {
        width: 0,
        height: 0,
      };

      if (this.isBordered) {
        this.border.width = parseFloat(this.$el.css('border-right-width'))
            + parseFloat(this.$el.css('border-left-width'));
        this.border.height = parseFloat(this.$el.css('border-top-width'))
            + parseFloat(this.$el.css('border-bottom-width'));
      }
    }

    postReset() {
      this.$el
        .removeClass(this.CLASS_FITTED)
        .addClass(this.CLASS_ORIGINAL)

      this.$el.css({
        flex: this.initialFlex,
        height: this.initialCssHeight || 'auto',
        width: this.initialCssWidth || 'auto',
      })

      this.$labeledMediaWrapper.css({
        flex: this.initialFlex,
        width: this.initialCssWidth || 'auto',
      })

      this.$labeledMediaWrapper.removeClass(this.alignmentClasses)
    }

    postCalculate() {
      const rect = this.$el[0].getBoundingClientRect();

      this.width = rect.width - this.border.width;
      this.height = rect.height - this.border.height;

      this.calculatedHeight = this.width / this.ratio;

      this.isFitted = this.calculatedHeight < this.height;
      if (!this.isFitted) {
        this.calculatedHeight = this.height;
      }

      this.calculatedWidth = this.height * this.ratio;
      if (this.calculatedWidth > this.width) {
        this.calculatedWidth = this.width;
      }

      this.calculatedWidth += this.border.width;
      this.calculatedHeight += this.border.height;
    }

    calculateWithConstraints(constraints) {
      if (!constraints.width) return;

      const width = constraints.width;
      const height = constraints.height;

      if (height) {
        this.calculatedHeight = height;
        this.calculatedWidth = this.calculatedHeight * this.ratio;

        if (this.calculatedWidth > this.width) {
          this.calculatedWidth = this.width;
          this.calculatedHeight = this.calculatedWidth / this.ratio;
        }
      } else {
        this.calculatedWidth = width;
        this.calculatedHeight = width / this.ratio;
      }
    }

    setHeight(height) {
      this.calculatedHeight = height;
      this.calculatedWidth = height * this.ratio;

      this.preRender();
    }

    preRender() {
      this.$el.removeClass(this.CLASS_ORIGINAL)

      if (this.isFitted) {
        this.$el.addClass(this.CLASS_FITTED)
      }

      this.$el.css({
        flex: this.FLEX_DEFAULTS,
        height: this.calculatedHeight,
        width: this.isCutted ? '100%' : this.calculatedWidth,
      })

      this.$labeledMediaWrapper.css({
        flex: this.FLEX_DEFAULTS,
        width: this.isCutted ? '100%' : this.calculatedWidth,
      })

      this.$labeledMediaWrapper.addClass(this.alignmentClasses)
    }
  }

  $('.js__fitToContent').each(function() {
    new FitToContentModule($(this))
  })
})
